import React, { ReactElement } from 'react'

export interface RadioButtonProps<T> {
  label: string;
  value: T;
}

const RadioButton: <T>(p: RadioButtonProps<T>) => ReactElement = ({ label }) => {
  const classes = `input-option`

  return (
    <span className={classes}>{label}</span>
  )
}

export default RadioButton